import React from 'react'

import TagView from '../../../gd-components/icons/tag/tag-view'
import VScroll from "../../../gd-components/scrolling/custom-v-scroll/v-scroll"
import SearchInput from "../../../gd-ui/search/search"
import ModalV4HeaderWhite from "../../../../app/ui/modal/v4/header-white/v4-header-white"
import ProjectSession from "../../../model2/project/project-session"

type Props = {
    params      : {
        tags        : ID[]
    }

    onTagSelect : func
    onClickNew  : func

    onClick     : func
}

type State = {
    searchString: string
}

// const debug = "AddTagExisting"
const debug = false

export default class AddTagExisting extends React.Component<Props, State> {

    private allOptions: ProjectSession[]

    constructor(props: Props) {
        super(props)

        this.state = {
            searchString: ''
        };

        const {tags} = this.props.params;

        this.allOptions = [];
        gd.session.projects.filterByCompany(gd.companyId).filterBySystemType(gd.const.project.type.TAG).map(t=>{
            if (t.isArchived || tags.includes(t.id)) {
                return
            }
            this.allOptions.push(t)
        })

        this.allOptions = _.sortBy(this.allOptions, [
            function(o) {
                return o.name.toLowerCase()
            }
        ])
    }

    onTagClick = (tagId: ID) => {
        this.props.onTagSelect(tagId)
    }

    onClickNew = () => {
        this.props.onClickNew()
    }

    onSearchChange = (searchString: string) => {
        this.setState({
            'searchString': searchString
        })
    }

    render() {
        let tags: ProjectSession[] = []

        _.map(this.allOptions, tag=>{
            if (!this.state.searchString || gd.utils.search(tag.name, this.state.searchString)) {
                tags.push(tag)
            }
        })

        const showNoTags = !tags || tags.length < 1

        debug && console.log(debug, 'render', tags)

        return (
            <div className  = "v4-container placement-middle select-existing"
                 onClick    = {this.props.onClick}
            >
                <ModalV4HeaderWhite
                    height  = {60}
                    title   = "Select a Tag"
                />
                <div className="main">
                    <VScroll containerClass="main-container">
                        <div className="flex-row-left-center border-box p-l-20 p-r-20 p-b-20">
                            <SearchInput
                                className   = "w-100p"
                                value       = {this.state.searchString}
                                onChange    = {this.onSearchChange}
                            />
                        </div>

                        <div className="tags-list">
                            {showNoTags &&
                                <div className="not-found">No tags found</div>}

                            {_.map(tags, (tag, key) => {
                                return (
                                    <TagView
                                        key         = {key}
                                        size        = "26"
                                        showIcon    = {true}
                                        tag         = {tag}
                                        onClick     = {this.onTagClick.bind(this, tag.id)}
                                    />
                                )
                            })}
                            {/*<div className="cf"/>*/}


                        </div>

                        <div className="block-new">
                            <div onClick={this.onClickNew}>+ New Tag</div>
                        </div>
                    </VScroll>
                </div>
            </div>
        )
    }
}